module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品详细")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px"
    }
  }, _vm._l((_vm.orderList), function(order) {
    return _c('div', {
      staticClass: "list-block media-list"
    }, [_c('ul', [_c('li', [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'goods'
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('img', {
      staticStyle: {
        "width": "4rem"
      },
      attrs: {
        "src": "/emktResources/resocurces/img/gene.jpg"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', [_vm._v(_vm._s(order.merchandiseLabel))])]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#d94b73"
      }
    }, [_vm._v("¥" + _vm._s(order.priceMax))]) : _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#d94b73"
      }
    }, [_vm._v("¥" + _vm._s(order.priceMin))]), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_vm._v("合计" + _vm._s(order.productQuantity) + "个产品")])])])], 1)])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2706b38e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/OrderConfirmDetail.vue
// module id = 1572
// module chunks = 8